<template>
  <v-expansion-panels :ref="'enode-advanced-settings-' + vehicleId" class="enode-advanced-setting" v-model="panel"
                      accordion>
    <v-expansion-panel v-model="panel" class="tileBackground">
      <v-expansion-panel-header class="font-weight-bold">{{
          $t('enode-connection-tile.advanced-settings.title')
        }}
      </v-expansion-panel-header>
      <v-expansion-panel-content class="pa-0">
        <v-skeleton-loader v-if="loadingRules"
                           type="article"
                           height="100"/>
        <v-simple-table v-else>
          <template v-slot:default>
            <tbody class="tileBackground">
            <tr v-show="isSmartChargingCapable">
              <td @click="openSmartCharging">
                <v-list-item class="list-item enode-rules-list-item straight">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ $t('enode-connection-tile.advanced-settings.smart-charging-onboarding.title') }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-show="!smartChargingConfigured && isSmartChargingCapable">
                      {{ $t('enode-connection-tile.advanced-settings.smart-charging-onboarding.not-configured') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </td>
              <td>
                <v-switch class="mt-0"
                          v-model="smartCharging.active"
                          @change="activateSmartCharging"
                          inset hide-details/>
              </td>
              <td @click="openSmartCharging">
                <v-icon color="primary">chevron_right</v-icon>
              </td>
            </tr>
            <tr v-show="!isSmartChargingCapable">
              <td>
                <v-list-item class="list-item enode-rules-list-item straight">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ $t('enode-connection-tile.advanced-settings.smart-charging-onboarding.title') }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-show="!isSmartChargingCapable">
                      {{ $t('enode-connection-tile.advanced-settings.smart-charging-onboarding.not-capable') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </td>
              <td/>
              <td/>
            </tr>
            <tr @click="openScheduleOverviewDialog()">
              <td>
                <v-list-item class="list-item enode-rules-list-item straight">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ $t('enode-connection-tile.advanced-settings.scheduling.title') }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-show="!isSchedulingConfigured">
                      {{ $t('enode-connection-tile.advanced-settings.scheduling.not-configured') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </td>
              <td>
              </td>
              <td>
                <v-icon color="primary">chevron_right</v-icon>
              </td>
            </tr>

            <tr :class="{'disabled-table-row': !hasMeter}">
              <td @click="hasMeter ? openGreenChargingSettings() : showTipsDialog(true)">
                <v-list-item class="list-item enode-rules-list-item straight">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ $t('enode-connection-tile.advanced-settings.green-charging.title') }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="greenChargingRule.hasRule">{{
                        $t('enode-connection-tile.advanced-settings.green-charging.subtitle', {value: greenChargingRule.greenChargingVal})
                      }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else>
                      {{ $t('enode-connection-tile.advanced-settings.green-charging.subtitle-empty-state') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </td>
              <td>
                <v-switch class="mt-0"
                          v-if="hasMeter"
                          v-model="greenChargingRule.active"
                          :disabled="loadingGreenChargingRule"
                          @change="greenChargingRule.hasRule ? saveGreenChargingRule() : openGreenChargingSettings()"
                          inset hide-details/>
                <v-icon class="material-icons-outlined"
                        @click="showTipsDialog(true)"
                        v-else
                        color="primary"
                        left>info
                </v-icon>
              </td>
              <td @click="hasMeter ? openGreenChargingSettings() : showTipsDialog(true)">
                <v-icon color="primary">chevron_right</v-icon>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>

      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>

import moment from "moment";
import momentTZ from "moment-timezone";
import requestHelper from "@/scripts/requestHelper";
import config from "@/config/config.app.json";
import store from "enode-lib/src/store"
import {createEnodeLib} from "@/plugins/enodePlugin";

export default {
  name: "EnodeAdvancedSettings",
  props: ['vehicleId', 'isSmartChargingCapable'],
  data() {
    return {
      panel: null,
      changeTime: false,
      changeFeed: false,
      meterList: [],
      loadingRules: false,
      loadingTimeBasedRule: false,
      loadingGreenChargingRule: false,
      greenChargingRule: {
        hasRule: false,
        active: false,
        meterDevice: null,
        greenChargingVal: 0
      },
      timeBasedChargingRule: {
        hasRule: false,
        active: false,
        triggerTime: "22:00:00"
      },
      smartCharging: {
        active: false
      },
      store: store,
      enodePlugin: createEnodeLib(),
    }
  },
  methods: {
    showTipsDialog(greenCharging = false) {
      let text = greenCharging ? this.$t('enode-connection-tile.info-dialog.info.text-2') : this.$t('enode-connection-tile.info-dialog.info.text')

      this.$root.bisadialog.toggle('infoText', true, {
        title: this.$t('enode-connection-tile.info-dialog.title'),
        icon: 'info',
        text: text
      })

    },
    openScheduleOverviewDialog() {
      this.$root.bisadialog.toggle('scheduleOverview', true, {
        vehicleId: this.vehicleId,
        smartChargingEnabled: this.smartCharging.active,
        greenChargingActive: this.greenChargingRule.active
      })
      //this.$root.bisadialog.callDialogInit('scheduleOverview')
    },
    openGreenChargingSettings() {
      this.$root.bisadialog.toggle('enodeGreenChargingSetting', true, {
        meterList: this.meterList,
        vehicleId: this.vehicleId
      })
      this.$root.bisadialog.callDialogInit('enodeGreenChargingSetting')
    },
    /**
     * continuously updates rules
     */
    updateData() {
      this.timer = setInterval(() => {
        this.getRules(false)
      }, config.updateInterval)
    },
    getRules(loadingScreen = true) {
      this.loadingRules = loadingScreen
      this.enodePlugin.getRules(this.vehicleId).then((resp) => {
        this.sortRules(resp?.data?.data)
        this.loadingRules = false
        this.panel = 0
      }).catch((err) => {
        this.loadingRules = false
        this.panel = 0
        console.error(err)
      })
    },
    sortRules(rules) {
      if (rules) {
        rules.forEach((rule) => {
          if (rule?.attributes?.condition?.type === 'timers') {
            this.timeBasedChargingRule.hasRule = true
            this.timeBasedChargingRule.id = rule?.id
            this.timeBasedChargingRule.triggerTime = moment(rule?.attributes?.condition?.triggerTime, "HH:mm:ss").format("HH:mm:ss")
            this.timeBasedChargingRule.active = !rule?.attributes?.deactivated
          } else if (rule?.attributes?.condition?.type === 'properties') {
            this.greenChargingRule.hasRule = true
            this.greenChargingRule.id = rule?.id
            this.greenChargingRule.meterDevice = rule?.attributes?.condition?.deviceId
            this.greenChargingRule.greenChargingVal = Number(rule?.attributes?.condition?.value)
            this.greenChargingRule.active = !rule?.attributes?.deactivated
          }
        })
      }
    },
    saveTimeBasedRule(isTimeChange, triggerTime) {
      this.changeTime = isTimeChange

      if (isTimeChange) {
        this.timeBasedChargingRule.triggerTime = triggerTime
      }
      if (this.timeBasedChargingRule.hasRule) {
        this.updateRule('timeBased')
      } else {
        this.addRule('timeBased')
      }
    },
    saveGreenChargingRule() {
      if (this.greenChargingRule.hasRule) {
        this.updateRule('greenCharging')
      } else {
        this.addRule('greenCharging')
      }
    },
    toggleTimeBasedCharging() {
      this.saveTimeBasedRule(false)
    },
    addRule(type) {
      let rule = this.manageRule(true, type)
      this.$rhRequest.sendPost({
        endpoint: 'rule/add',
        data: rule.data
      }, () => {
        this.manageRule(false, type)
        this.getRules()
      }, (err) => {
        this.manageRule(false, type)
        console.error(err)
      })
    },
    updateRule(type) {
      let rule = this.manageRule(true, type)

      this.$rhRequest.sendPost({
        endpoint: 'rule/update',
        params: {
          "id": rule.id
        },
        data: rule.data
      }, () => {
        this.manageRule(false, type)
        this.getRules()
      }, (err) => {
        this.manageRule(false, type)
        console.error(err)
      })
    },
    manageRule(startLoading, type) {
      if (startLoading) {
        let data, id
        if (type === 'timeBased') {
          data = this.timeBasedChargingData
          id = this.timeBasedChargingRule?.id
          this.loadingTimeBasedRule = true
        } else if (type === 'greenCharging') {
          data = this.greenChargingData
          id = this.greenChargingRule?.id
          this.loadingGreenChargingRule = true
        }
        return {
          id: id,
          data: data
        }
      } else {
        if (type === 'timeBased') {
          this.loadingTimeBasedRule = false
        } else if (type === 'greenCharging') {
          this.loadingGreenChargingRule = false
        }
      }
    },
    openSmartCharging() {
      this.$root.bisadialog.toggle('smartChargingOnboarding', true, {vehicleId: this.vehicleId})
    },
    activateSmartCharging() {
      if (this.smartChargingConfigured) {
        this.updateSmartChargingPolicy()
      } else {
        this.openSmartCharging()
      }
    },
    updateSmartChargingPolicy() {
      let policyUpdate = {
        isEnabled: this.smartCharging.active,
        minimumChargeLimit: this.smartChargingPolicy.minimumChargeLimit = 0,
        deadline: this.smartChargingPolicy.deadline
      }
      this.enodePlugin.updateSmartChargingPolicy(this.vehicleId, policyUpdate).catch((error) => {
        if (error.response?.status === 409) {
          this.$root.bisatoast.error({
            message: this.$t('enode-connection-tile.advanced-settings.another-user-activated-smart-charging'),
            showCloseBtn: true
          })
        } else {
          this.smartCharging.active = !this.smartCharging.active
          this.$root.bisatoast.error({message: this.$t('app.generic-error'), showCloseBtn: true})
        }
      })
    }
  },
  mounted() {
    this.getRules()

    requestHelper.startDelayedRequest(
        () => this.getRules(),
        () => this.updateData()
    )

    // Set listener for component specific triggerTimeChange
    this.$root.$on('triggerTimeChange-' + this.vehicleId, (isTimeChange, triggerTime) => {
      this.saveTimeBasedRule(isTimeChange, triggerTime)
    })
    this.$root.$on('updateSmartCharging', () => {
    })

    // Set listener for component specific triggerGreenCharging
    this.$root.$on('triggerGreenCharging-' + this.vehicleId, (meterDevice) => {
      this.greenChargingRule.greenChargingVal = meterDevice.value
      this.greenChargingRule.meterDevice = meterDevice.deviceId
      this.saveGreenChargingRule()
    })
    this.$root.$on('deactivateOtherRules-' + this.vehicleId, () => {
      if (this.greenChargingRule.active || this.greenChargingRule.hasRule) {
        this.greenChargingRule.active = false
        this.saveGreenChargingRule()
      }
      if (this.smartCharging.active) {
        this.smartCharging.active = false
        this.updateSmartChargingPolicy()
      }
    })
    this.smartCharging.active = this.smartChargingPolicy?.isEnabled
  },
  beforeDestroy() {
    this.$root.$off('triggerTimeChange-' + this.vehicleId)
    this.$root.$off('triggerGreenCharging-' + this.vehicleId)
    this.$root.$off('updateSmartCharging')
  },
  computed: {
    displayTriggerTime() {
      return moment(this.timeBasedChargingRule.triggerTime, "HH:mm:ss").format("HH:mm")
    },
    timeBasedChargingData() {
      return {
        "name": "Planned Charging: " + this.vehicleId,
        "iconKey": "auto_awesome",
        "deactivated": this.timeBasedChargingDeactivated,
        "condition": {
          "type": "timers",
          "weekdays": [true, true, true, true, true, true, true],
          "startTime": moment().format("YYYY-MM-DD") + " 00:00:00",
          "triggerTime": this.timeBasedChargingRule.triggerTime,
          "timerType": "DAILY",
          "timezone": momentTZ.tz.guess()
        },
        "action": {
          "type": "chargeActions",
          "vehicleId": this.vehicleId,
          "action": "START"
        },
        "synced": "PENDING",
        "hidden": true
      }
    },
    greenChargingData() {
      return {
        "name": "Green charging: " + this.vehicleId,
        "iconKey": "auto_awesome",
        "deactivated": this.greenChargingDeactivated,
        "condition": {
          "type": "properties",
          "deviceId": this.greenChargingRule.meterDevice,
          "property": "feed-current",
          "constraint": ">",
          "value": this.greenChargingRule.greenChargingVal
        },
        "action": {
          "type": "chargeActions",
          "vehicleId": this.vehicleId,
          "action": "START"
        },
        "synced": "PENDING",
        "hidden": true
      }
    },
    timeBasedChargingDeactivated() {
      if (this.changeTime) {
        return this.timeBasedChargingRule.active
      } else {
        return !this.timeBasedChargingRule.active
      }
    },
    greenChargingDeactivated() {
      if (this.changeFeed) {
        return this.greenChargingRule.active
      } else {
        return !this.greenChargingRule.active
      }
    },
    smartChargingConfigured() {
      return this.store.sharedState.chargeLocations?.length > 0 && this.smartCharging.smartChargingPolicy?.deadline !== null
    },
    isSchedulingConfigured() {
      return this.store.sharedState.schedules?.length > 0
    },
    smartChargingPolicy() {
      return this.store.sharedState.smartChargingPolicies.find(p => p.id === this.vehicleId)?.policy || {
        minimumChargeLimit: 0,
        deadline: "",
        isEnabled: false,
      }
    },
    hasGateway() {
      return !!this.store.sharedState.automationAttributes.hasGateway
    },
    hasMeter() {
      return !!this.store.sharedState.automationAttributes.hasMeter
    },
  },
  watch: {
    smartChargingPolicy: {
      handler(newPolicy) {
        this.smartCharging.active = newPolicy.isEnabled
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/living/e-mobility.scss';
</style>
